module.exports = __webpack_public_path__ + "static/media/parent_notification_icon.9da6b039.svg";